module.exports = __webpack_public_path__ + "static/media/logo-brejo.2cf4d700.png";